import React from 'react';
import PageWrapper from './PageWrapper';
import { heights, widths, fonts } from './../styles/theme.json';

const WysywgPage = (props) => {
  return (
    <PageWrapper>
      <section id={'wysywg-page'}>
        <h1>{props.data.title}</h1>
        <article className={'formatted-markup'} dangerouslySetInnerHTML={{__html:props.data.content}}/>
      </section>
      <style jsx>{`
        #wysywg-page {
          margin-top: ${heights.header};
          max-width: ${widths.global_max_width};
          text-align: center;
          padding: 5rem 2.5rem;
          display: flex;
          flex-direction: column;
        }
        h1 {
          margin-bottom: 3rem;
          display: block;
          width: 100%;
          text-align: center;
          font-size: ${fonts.big_headline};
        }
        article {
          max-width: 70rem;
          margin: 0 auto;
          text-align: left;
        }
      `}</style>
    </PageWrapper>
  );
};

export default WysywgPage;



// WEBPACK FOOTER //
// ./src/components/WsywygPage.js